import { render, staticRenderFns } from "./CreateInterview.vue?vue&type=template&id=64e0a6de&"
import script from "./CreateInterview.vue?vue&type=script&lang=js&"
export * from "./CreateInterview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports